import { useNavigate } from '@tanstack/react-router';
import { UserCog } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../lib/auth';

/** Persistent, non-dismissable bar shown on every page while a platform
 * admin is "Anzeigen als" (Plattform › Benutzeraccounts) — the whole point
 * is that it can never be mistaken for a normal session. Renders nothing
 * once `me.impersonatedByEmail` is unset. */
export function ImpersonationBanner() {
  const { me, exitImpersonation } = useAuth();
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);

  if (!me?.impersonatedByEmail) return null;

  const targetLabel = me.user.firstName ? `${me.user.firstName} (${me.user.email})` : me.user.email;

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-500 px-4 py-2 text-center text-sm font-medium text-amber-950">
      <UserCog size={16} className="shrink-0" />
      <span>
        Angezeigt als <strong>{targetLabel}</strong> — gestartet von {me.impersonatedByEmail}
      </span>
      <button
        type="button"
        disabled={pending}
        onClick={async () => {
          setPending(true);
          try {
            await exitImpersonation();
            await navigate({ to: '/' });
          } finally {
            setPending(false);
          }
        }}
        className="rounded-md bg-amber-950/10 px-2.5 py-1 font-semibold hover:bg-amber-950/20 disabled:opacity-50"
      >
        {pending ? 'Wird beendet…' : 'Beenden'}
      </button>
    </div>
  );
}
